
/*
    🔥 LOGO DE MARCA Y CALENDARIO FESTIVO
    GET_COMPANY_LOGO  → devuelve el <div> armado en HTML plano
        GET_ACTIVE_LOGO → qué logo corresponde según la date (navidad, bandera, base...)
*/

import { APP_COMPANY_CONFIG } from "./AppCompanyConfig";


const FORCE_LOGO = null;   // Solo test: "navidad" | "bandera" | "base" | null

const IMGS = APP_COMPANY_CONFIG.COMPANY_IMGS;

const LOGO_BASE_DARK = IMGS.BRAND_DARK;
const LOGO_BASE_LIGHT = IMGS.BRAND_LIGHT;

const LOGO_XMAS_DARK = IMGS.XMAS_DARK;
const LOGO_XMAS_LIGHT = IMGS.XMAS_LIGHT;

const LOGO_FLAG_LIGHT = IMGS.FLAG_LIGHT;
const LOGO_FLAG_DARK = IMGS.FLAG_DARK;


// ---------------------------------------- 🔥 CALENDARIO
const LOGO_CALENDAR = [
    {
        id: "navidad", label: "Navidad",
        from: [12, 8], to: [12, 26],
        assets: { light: LOGO_XMAS_LIGHT, dark: LOGO_XMAS_DARK },
        info_description: "Celebración de las fiestas navideñas y armado del árbol de Navidad.",
    },
    {
        id: "anio_nuevo", label: "Año Nuevo",
        from: [12, 27], to: [1, 6],
        assets: { light: LOGO_BASE_LIGHT, dark: LOGO_BASE_DARK },
        info_description: "Conmemoración del inicio del nuevo año y llegada de los Reyes Magos.",
    },
    {
        id: "bandera", label: "Día de la Bandera",
        from: [6, 20], to: [6, 20],
        assets: { light: LOGO_FLAG_LIGHT, dark: LOGO_FLAG_DARK },
        info_description: "Paso a la inmortalidad del General Manuel Belgrano, creador de la bandera argentina.",
    },
    {
        id: "revolucion_mayo", label: "25 de Mayo",
        from: [5, 25], to: [5, 25],
        assets: { light: LOGO_FLAG_LIGHT, dark: LOGO_FLAG_DARK },
        info_description: "Conmemoración de la Revolución de Mayo de 1810 y la conformación del primer Gobierno Patrio.",
    },
    {
        id: "independencia", label: "9 de Julio",
        from: [7, 9], to: [7, 9],
        assets: { light: LOGO_FLAG_LIGHT, dark: LOGO_FLAG_DARK },
        info_description: "Declaración de la Independencia Argentina firmada en San Miguel de Tucumán en 1816.",
    },
    {
        id: "malvinas", label: "Día de Malvinas",
        from: [4, 2], to: [4, 2],
        assets: { light: LOGO_FLAG_LIGHT, dark: LOGO_FLAG_DARK },
        info_description: "Día del Veterano y de los Caídos en la Guerra de Malvinas.",
    },
    {
        id: "guemes", label: "Día de Güemes",
        from: [6, 17], to: [6, 17],
        assets: { light: LOGO_FLAG_LIGHT, dark: LOGO_FLAG_DARK },
        info_description: "Paso a la inmortalidad del General Martín Miguel de Güemes, héroe de la independencia.",
    },
    {
        id: "san_martin", label: "Día de San Martín",
        from: [8, 17], to: [8, 17],
        assets: { light: LOGO_FLAG_LIGHT, dark: LOGO_FLAG_DARK },
        info_description: "Paso a la inmortalidad del General José de San Martín, Padre de la Patria y Libertador.",
    },
    {
        id: "diversidad_cultural",
        label: "Respeto a la Cultura",
        from: [10, 12], to: [10, 12],
        assets: { light: LOGO_FLAG_LIGHT, dark: LOGO_FLAG_DARK },
        info_description: "Jornada para promover el respeto por la diversidad cultural y el diálogo entre los pueblos.",
    },
    {
        id: "soberania", label: "Día de la Soberanía Nacional",
        from: [11, 20], to: [11, 20],
        assets: { light: LOGO_FLAG_LIGHT, dark: LOGO_FLAG_DARK },
        info_description: "Conmemoración de la Batalla de Vuelta de Obligado de 1845 en defensa del territorio nacional.",
    },
    {
        id: "san_valentin", label: "San Valentín",
        from: [2, 14], to: [2, 14],
        assets: { light: LOGO_BASE_LIGHT, dark: LOGO_BASE_DARK },
        info_description: "Celebración del Día de los Enamorados y la amistad.",
    },
    {
        id: "dia_trabajador", label: "Día del Trabajador",
        from: [5, 1], to: [5, 1],
        assets: { light: LOGO_FLAG_LIGHT, dark: LOGO_FLAG_DARK },
        info_description: "Homenaje a las luchas por los derechos laborales y el valor del trabajo.",
    },
    {
        id: "dia_amigo", label: "Día del Amigo",
        from: [7, 20], to: [7, 20],
        assets: { light: LOGO_BASE_LIGHT, dark: LOGO_BASE_DARK },
        info_description: "Celebración especial de los lazos de amistad y fraternidad.",
    },
    {
        id: "primavera", label: "Día de la Primavera",
        from: [9, 21], to: [9, 21],
        assets: { light: LOGO_BASE_LIGHT, dark: LOGO_BASE_DARK },
        info_description: "Festejo del inicio de la primavera y el Día del Estudiante.",
    },
];

const LOGO_DEFAULT = {
    id: "base", label: "Logo institucional", assets: { light: LOGO_BASE_LIGHT, dark: LOGO_BASE_DARK },
};


const IN_RANGE = (mes, dia, from, to) => {
    const current = mes * 100 + dia;
    const from_index_value = from[0] * 100 + from[1];
    const until = to[0] * 100 + to[1];

    if (from_index_value <= until) return current >= from_index_value && current <= until;
    // Período que cruza el 31/12
    return current >= from_index_value || current <= until;
};

export const GET_ACTIVE_LOGO = (date_new = new Date()) => {
    // Si forzado no es null
    if (FORCE_LOGO) {
        if (FORCE_LOGO === LOGO_DEFAULT.id) return LOGO_DEFAULT;

        const forced = LOGO_CALENDAR.find(e => e.id === FORCE_LOGO);
        if (forced) return forced;
    }

    const month = date_new.getMonth() + 1;
    const day = date_new.getDate();

    return LOGO_CALENDAR.find(e => IN_RANGE(month, day, e.from, e.to)) || LOGO_DEFAULT;
};

export const APP_LOGO_CALENDAR = LOGO_CALENDAR;


// ---------------------------------------- 🔥 LOGO EN HTML PLANO
/*
    type → "default" dibuja las DOS imágenes y el CSS decide cuál se ve según el tema. "light" / "dark" 
    fuerzan UNA sola (mail y PDF no entienden de temas).

    dbLogoUrl → si la base manda un logo propio, ese GANA: pisa el calendario y se usa para claro y oscuro por 
    igual, porque no tenemos las dos variantes.

    date → sólo para testear un día puntual del calendario.
*/
export const GET_COMPANY_LOGO = (type = "default", dbLogoUrl = null, date = new Date()) => {
    const LOGO = GET_ACTIVE_LOGO(date);

    const ASSETS = dbLogoUrl ? { light: dbLogoUrl, dark: dbLogoUrl } : LOGO.assets;
    const LOGO_ID = dbLogoUrl ? "db" : LOGO.id;

    const FALLBACK_TEXT = `<span class="LStudio__app_content_company_logo_text">${APP_COMPANY_CONFIG.COMPANY_NAME}</span>`;

    const ON_ERROR = "this.closest('.LStudio__app_container_company_logo_container').classList.add('is-broken');";

    // Variante forzada: una sola imagen, sin depender del tema.
    if (type === "light" || type === "dark") {
        return `<div class="LStudio__app_container_company_logo_container" data-logo="${LOGO_ID}" data-variant="${type}">
            <img class="LStudio__app_content_company_logo_img"
                 src="${ASSETS[type]}" alt="Logo ${APP_COMPANY_CONFIG.COMPANY_NAME}" onerror="${ON_ERROR}" />
            ${FALLBACK_TEXT}
        </div>`.replace(/\s+/g, ' ').trim();
    }

    return `<div class="LStudio__app_container_company_logo_container" data-logo="${LOGO_ID}">
        <img class="LStudio__app_content_company_logo_img LStudio__app_content_company_logo_img_for_light"
             src="${ASSETS.light}" alt="Logo ${APP_COMPANY_CONFIG.COMPANY_NAME}" onerror="${ON_ERROR}" />
        <img class="LStudio__app_content_company_logo_img LStudio__app_content_company_logo_img_for_dark"
             src="${ASSETS.dark}" alt="Logo ${APP_COMPANY_CONFIG.COMPANY_NAME}" onerror="${ON_ERROR}" />
        ${FALLBACK_TEXT}
    </div>`.replace(/\s+/g, ' ').trim();
};